export default function SafePalWallet(props) {
  return (
    <img {...props} src="/images/safe.png" alt="" />
  )
}

